export interface Contact {
  id: string
  email: string
  name: string
  status: "active" | "passive"
}

export const DUMMY_CONTACTS: Contact[] = [
  { id: "1", email: "akshay.g@instavc.com", name: "Akshay G", status: "active" },
  { id: "2", email: "akshay23@yopmail.com", name: "Akshay 23", status: "active" },
  { id: "3", email: "akshayinst@yopmail.com", name: "Akshay Inst", status: "active" },
  { id: "4", email: "ramakrishna@instavc.com", name: "Ramakrishna", status: "active" },
  { id: "5", email: "syed@instavc.com", name: "Syed Yusuf", status: "active" },
  { id: "6", email: "mike@instavc.com", name: "Mike Chen", status: "passive" },
  { id: "7", email: "sarah@instavc.com", name: "Sarah Johnson", status: "passive" },
  { id: "8", email: "david@instavc.com", name: "David Lee", status: "passive" },
]

export function getContactById(id: string): Contact | undefined {
  return DUMMY_CONTACTS.find((c) => c.id === id)
}

export function getContactsByIds(ids: string[]): Contact[] {
  return ids.map((id) => getContactById(id)).filter(Boolean) as Contact[]
}

export function getContactByEmail(email: string, pool: Contact[] = DUMMY_CONTACTS): Contact | undefined {
  const lower = email.toLowerCase()
  return pool.find((c) => c.email.toLowerCase() === lower)
}

export function getContactsByEmails(emails: string[], pool: Contact[] = DUMMY_CONTACTS): Contact[] {
  return emails.map((email) => {
    const found = getContactByEmail(email, pool)
    if (found) return found
    return { id: email, email, name: email, status: 'active' as const }
  })
}
